(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
/*
  Address form enhancement.

  Two jobs, both optional:

    1. fill the province select from the data-provinces attribute that the
       country_option_tags object puts on every country option, and hide the
       whole field for countries that have no provinces
    2. ask before a delete actually posts

  With this file blocked the country select still posts, the <noscript>
  province text input takes over, and delete still works. Nothing here is
  load bearing.
*/
(function () {
  "use strict";

  if (window.smarteinAddressBound) return;
  window.smarteinAddressBound = true;

  var fillProvinces = function (countrySelect) {
    var form = countrySelect.form;
    if (!form) return;

    var wrapper = form.querySelector("[data-address-province-wrapper]");
    var provinceSelect = form.querySelector("[data-address-province]");
    if (!wrapper || !provinceSelect) return;

    var option = countrySelect.options[countrySelect.selectedIndex];
    var raw = option ? option.getAttribute("data-provinces") : null;
    var provinces = [];

    try {
      provinces = raw ? JSON.parse(raw) : [];
    } catch (error) {
      provinces = [];
    }

    var wanted = provinceSelect.getAttribute("data-selected") || "";
    provinceSelect.innerHTML = "";

    if (!provinces.length) {
      wrapper.setAttribute("hidden", "hidden");
      return;
    }

    provinces.forEach(function (province) {
      var opt = document.createElement("option");
      opt.value = province[0];
      opt.textContent = province[1];
      if (province[0] === wanted || province[1] === wanted) opt.selected = true;
      provinceSelect.appendChild(opt);
    });

    wrapper.removeAttribute("hidden");
  };

  var init = function () {
    document.querySelectorAll("[data-address-country]").forEach(function (select) {
      var wanted = select.getAttribute("data-selected");
      if (wanted) {
        Array.prototype.forEach.call(select.options, function (option, index) {
          if (option.value === wanted) select.selectedIndex = index;
        });
      }
      fillProvinces(select);
    });
  };

  document.addEventListener("change", function (event) {
    var select = event.target.closest("[data-address-country]");
    if (select) fillProvinces(select);
  });

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form.classList || !form.classList.contains("address-delete")) return;

    var button = form.querySelector("[data-confirm-message]");
    var message = button ? button.getAttribute("data-confirm-message") : null;

    if (message && !window.confirm(message)) event.preventDefault();
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"] && !Shopify.designMode) return;
  try {
    
/*
  Cart page enhancement.

  Every control it binds is already a working native control, so this file is
  optional by design. What it adds:

    - the minus, plus and remove links stop being page loads and become
      /cart/change.js calls
    - typing a quantity and leaving the field applies immediately, so the
      Update button becomes a fallback rather than a step
    - the section is repainted from the Section Rendering API response that
      /cart/change.js returns, so subtotals, discounts and line totals stay
      correct without a reload
    - the header [data-cart-count] badge is updated from the same response

  Nothing here talks to the Storefront API. There is no token in the theme.
*/
(function () {
  "use strict";

  if (window.smarteinCartPageBound) return;
  window.smarteinCartPageBound = true;

  var rootUrl = function () {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    return "/";
  };

  var currentSection = function () {
    return document.querySelector("[data-section-type='main-cart']");
  };

  var setBusy = function (busy) {
    var section = currentSection();
    if (section) section.setAttribute("aria-busy", busy ? "true" : "false");
  };

  var paintCount = function (cart) {
    if (!cart || typeof cart.item_count !== "number") return;
    document.querySelectorAll("[data-cart-count]").forEach(function (node) {
      node.textContent = cart.item_count;
    });
  };

  var repaint = function (cart) {
    paintCount(cart);

    var section = currentSection();
    var sectionId = section ? section.getAttribute("data-section-id") : null;
    var html = cart && cart.sections ? cart.sections[sectionId] : null;

    if (!html || !section) {
      window.location.reload();
      return;
    }

    var parsed = new DOMParser().parseFromString(html, "text/html");
    var fresh = parsed.querySelector("[data-section-type='main-cart']");

    if (!fresh) {
      window.location.reload();
      return;
    }

    section.replaceWith(fresh);
    fresh.querySelectorAll(".reveal").forEach(function (node) {
      node.classList.add("is-visible");
    });
    setBusy(false);
  };

  var change = function (line, quantity) {
    var section = currentSection();
    if (!section) return;

    setBusy(true);

    fetch(rootUrl() + "cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: section.getAttribute("data-section-id"),
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error("cart change failed");
        return response.json();
      })
      .then(repaint)
      .catch(function () {
        window.location.reload();
      });
  };

  document.addEventListener("click", function (event) {
    var control = event.target.closest("[data-cart-change]");
    if (!control) return;
    if (!control.closest("[data-section-type='main-cart']")) return;

    event.preventDefault();
    change(
      parseInt(control.getAttribute("data-line"), 10),
      parseInt(control.getAttribute("data-quantity"), 10)
    );
  });

  document.addEventListener("change", function (event) {
    var input = event.target.closest("[data-cart-quantity]");
    if (!input) return;
    if (!input.closest("[data-section-type='main-cart']")) return;

    var quantity = parseInt(input.value, 10);
    if (isNaN(quantity) || quantity < 0) quantity = 0;

    change(parseInt(input.getAttribute("data-line"), 10), quantity);
  });

  // The order note is the one field the Update button still owns natively, so
  // it is saved on blur to keep the button honest about what it does.
  document.addEventListener(
    "blur",
    function (event) {
      var note = event.target.closest("#CartNote");
      if (!note) return;

      fetch(rootUrl() + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({ note: note.value })
      }).catch(function () {});
    },
    true
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
/*
  Sort select: submit on change so the native GET form needs no button. With
  the script blocked the <noscript> button submits it instead, so sorting
  never depends on JavaScript.
*/
(function () {
  "use strict";

  if (window.smarteinCollectionSortBound) return;
  window.smarteinCollectionSortBound = true;

  document.addEventListener("change", function (event) {
    var select = event.target.closest("[data-collection-sort]");
    if (!select) return;
    var form = select.closest("form");
    if (form) form.submit();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
/*
  Gallery thumbnails.

  Progressive enhancement only. With this script blocked the page still shows
  the featured image and every thumbnail is still a real button that does
  nothing, so nothing is lost that the mirror ever had: the mirror had a single
  static image.
*/
(function () {
  "use strict";

  if (window.smarteinPdpGalleryBound) return;
  window.smarteinPdpGalleryBound = true;

  document.addEventListener("click", function (event) {
    var thumb = event.target.closest("[data-pdp-thumb]");
    if (!thumb) return;

    var hero = thumb.closest("[data-pdp-hero]");
    if (!hero) return;

    var main = hero.querySelector("[data-pdp-media-main]");
    if (!main) return;

    main.setAttribute("src", thumb.getAttribute("data-src"));
    main.setAttribute("srcset", thumb.getAttribute("data-srcset"));
    main.setAttribute("alt", thumb.getAttribute("data-alt") || "");

    hero.querySelectorAll("[data-pdp-thumb]").forEach(function (node) {
      node.setAttribute("aria-current", node === thumb ? "true" : "false");
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
/*
  Add to cart without leaving the grid.

  Pure progressive enhancement over the native form inside every card. With
  this script blocked the form still posts to /cart/add and Shopify redirects
  to the cart page, which is the behaviour the theme ships with.

  The mirror kept the shopper on the page after an add, so this does the same:
  post to /cart/add.js, refresh the header count, flash the button label, and
  put it back. It stands down the moment the cart drawer section exists, so the
  drawer owns the interaction and nothing is bound twice.
*/
(function () {
  "use strict";

  if (window.smarteinGridAddBound) return;
  window.smarteinGridAddBound = true;

  var labelTimers = new WeakMap();

  var refreshCount = function () {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart.js" : "/cart.js", {
      headers: { Accept: "application/json" }
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll("[data-cart-count]").forEach(function (node) {
          node.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  };

  var flash = function (button, label) {
    if (!button || !label) return;
    if (!button.dataset.restLabel) button.dataset.restLabel = button.textContent;
    button.textContent = label;
    window.clearTimeout(labelTimers.get(button));
    labelTimers.set(
      button,
      window.setTimeout(function () {
        button.textContent = button.dataset.restLabel;
        button.disabled = false;
      }, 1600)
    );
  };

  document.addEventListener("submit", function (event) {
    var form = event.target.closest(".card-add-form");
    if (!form) return;
    if (document.querySelector("[data-cart-drawer]")) return;

    var grid = form.closest("[data-product-grid]");
    if (!grid) return;

    event.preventDefault();

    var button = form.querySelector("button[type=submit]");
    if (button) button.disabled = true;

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw new Error("add failed");
        return refreshCount();
      })
      .then(function () {
        flash(button, grid.getAttribute("data-added-label"));
      })
      .catch(function () {
        form.submit();
      });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz"] && !Shopify.designMode) return;
  try {
    
/* Flavour quiz. Same decision tree as the static mirror, with the flavour data
   read from the JSON the section renders instead of a hardcoded object. */
(function () {
  function initQuiz(root) {
    if (!root || root.dataset.quizReady === 'true') return;

    var dataEl = root.querySelector('[data-quiz-data]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var questions = data.questions || [];
    var results = data.results || [];
    var strings = data.strings || {};
    if (!questions.length || !results.length) return;

    root.dataset.quizReady = 'true';

    var elQuestion = root.querySelector('[data-quiz-question]');
    var elOptions = root.querySelector('[data-quiz-options]');
    var elProgressText = root.querySelector('[data-quiz-progress-text]');
    var elProgressFill = root.querySelector('[data-quiz-progress-fill]');
    var elStep = root.querySelector('[data-quiz-step]');
    var elEmail = root.querySelector('[data-quiz-email]');
    var elResult = root.querySelector('[data-quiz-result]');
    var elResultName = root.querySelector('[data-quiz-result-name]');
    var elResultDesc = root.querySelector('[data-quiz-result-desc]');
    var elResultImage = root.querySelector('[data-quiz-result-image]');
    var elResultCta = root.querySelector('[data-quiz-result-cta]');
    var elRestart = root.querySelector('[data-quiz-restart]');
    var elForm = root.querySelector('[data-quiz-email] form');
    var elEmailInput = root.querySelector('[data-quiz-email-input]');
    var elSkip = root.querySelector('[data-quiz-skip]');
    var elTags = root.querySelector('[data-quiz-tags]');

    if (!elQuestion || !elOptions || !elStep || !elResult) return;

    var useEmail = data.captureEmail === true && elEmail && elForm;
    var baseTags = elTags ? elTags.value : '';
    var current = 0;
    var scores = {};
    var winner = results[0];

    function fill(template, replacements) {
      var out = template || '';
      Object.keys(replacements).forEach(function (token) {
        out = out.split(token).join(replacements[token]);
      });
      return out;
    }

    function resetScores() {
      scores = {};
      results.forEach(function (result) {
        scores[result.id] = 0;
      });
    }

    function renderQuestion() {
      var q = questions[current];
      elQuestion.textContent = q.q;
      elOptions.innerHTML = '';
      q.options.forEach(function (opt, idx) {
        var btn = document.createElement('button');
        btn.className = 'quiz-option';
        btn.type = 'button';
        btn.textContent = opt.text;
        btn.addEventListener('click', function () {
          selectOption(idx);
        });
        elOptions.appendChild(btn);
      });
      if (elProgressText) {
        elProgressText.textContent = fill(strings.progress, {
          __CURRENT__: current + 1,
          __TOTAL__: questions.length
        });
      }
      if (elProgressFill) {
        elProgressFill.style.width = ((current + 1) / questions.length * 100) + '%';
      }
    }

    function selectOption(idx) {
      var opt = questions[current].options[idx];
      Object.keys(opt.scores || {}).forEach(function (key) {
        scores[key] = (scores[key] || 0) + opt.scores[key];
      });
      current++;
      if (current < questions.length) {
        renderQuestion();
      } else {
        pickWinner();
        if (useEmail) {
          showEmailGate();
        } else {
          showResult();
        }
      }
    }

    /* Only flavours that resolved to a live product are candidates. A flavour
       with no product, Strawberry today, still collects points but can never
       win, so the quiz never links to a URL that does not exist. */
    function pickWinner() {
      var max = -1;
      winner = results[0];
      results.forEach(function (result) {
        var score = scores[result.id] || 0;
        if (score > max) {
          max = score;
          winner = result;
        }
      });
      if (elTags) {
        elTags.value = baseTags ? baseTags + ', quiz-' + winner.id : 'quiz-' + winner.id;
      }
    }

    function showEmailGate() {
      elStep.classList.add('hidden');
      elEmail.classList.remove('hidden');
      if (elEmailInput) elEmailInput.focus();
    }

    function showResult() {
      elStep.classList.add('hidden');
      if (elEmail) elEmail.classList.add('hidden');
      if (elResultName) elResultName.textContent = winner.name;
      if (elResultDesc) elResultDesc.textContent = winner.desc;
      if (elResultImage) {
        if (winner.image) {
          elResultImage.src = winner.image;
          elResultImage.alt = fill(strings.imageAlt, { __NAME__: winner.name });
        } else {
          elResultImage.removeAttribute('src');
          elResultImage.alt = '';
        }
      }
      if (elResultCta) {
        elResultCta.textContent = fill(strings.cta, { __NAME__: winner.name });
        elResultCta.href = winner.url;
      }
      elResult.classList.remove('hidden');
    }

    function restart() {
      current = 0;
      resetScores();
      winner = results[0];
      if (elTags) elTags.value = baseTags;
      elResult.classList.add('hidden');
      if (elEmail) elEmail.classList.add('hidden');
      elStep.classList.remove('hidden');
      renderQuestion();
    }

    if (useEmail) {
      elForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = elEmailInput ? elEmailInput.value.trim() : '';
        if (email) {
          /* Posted in the background so the visitor never leaves the result.
             A failed subscribe must not block the result, so the catch is
             deliberately silent. */
          fetch(elForm.action, {
            method: 'POST',
            body: new FormData(elForm),
            headers: { Accept: 'text/html' }
          }).catch(function () {});
        }
        showResult();
      });
    }

    if (elSkip) {
      elSkip.addEventListener('click', showResult);
    }

    if (elRestart) {
      elRestart.addEventListener('click', restart);
      elRestart.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          restart();
        }
      });
    }

    resetScores();
    renderQuestion();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-quiz]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
